import { css } from 'styled-components'

/**
 * The grid's column-title typography, published as custom properties on the
 * grid container.
 *
 * `ListViewTable` applies these to `.ag-header-cell-label`, which AG Grid
 * renders on every standard header. Custom headers (e.g. ActionColumnHeader)
 * have no such element, so they read the properties directly to stay in sync.
 */
export const headerLabelVars = css`
  --list-view-header-label-font-size: 0.75rem;
  --list-view-header-label-font-weight: 700;
  --list-view-header-label-text-transform: uppercase;
`

export const headerLabelStyles = css`
  font-size: var(--list-view-header-label-font-size);
  font-weight: var(--list-view-header-label-font-weight);
  text-transform: var(--list-view-header-label-text-transform);
`
